import type { Routes } from '@angular/router';
import { ProductResolverService } from '@scalefast/ecommerce-core';
import { defaultPageOptions } from 'src/app/core/models';
import { PageLayout } from 'src/app/layout/layout.enum';

const productPageOptions = {
  pageProvider: '',
  name: '',
  type: '',
  pageType: PageLayout.Default,
  customClass: 'product-page__wrapper',
  extraData: {
    title: '',
    id: '',
    path: '',
    components: {
      global: true,
      advantage: true,
      footer: true,
      header: true,
      newsletter: true,
      breadcrumbs: true,
      customComponents: null,
    },
  },
};

export const productComponentRoutes: Routes = [
  {
    path: 'product',
    children: [
      {
        path: ':productId',
        loadComponent: () => import('./product.component').then((m) => m.AppProductComponent),
        data: {
          breadcrumb: (data: any) => data.product.descriptions[0].title.replace(/(.{50})..+/, '$1…'),
        },
        resolve: { product: ProductResolverService },
      },
      {
        path: ':productId/:productSlug',
        loadComponent: () => import('./product.component').then((m) => m.AppProductComponent),
        data: {
          breadcrumb: (data: any) => data.product.descriptions[0].title.replace(/(.{50})..+/, '$1…'),
        },
        resolve: { product: ProductResolverService },
      },
    ],
    data: {
      page: productPageOptions,
    },
  },
  {
    path: 'products',
    loadComponent: () => import('./product.component').then((m) => m.AppProductComponent),
    data: {
      breadcrumb: (data: any) => data.product.descriptions[0].title.replace(/(.{50})..+/, '$1…'),
      page: defaultPageOptions,
    },
    resolve: { product: ProductResolverService },
  },
];
